import React, {Component} from 'react';
import Thead from "./Thead";
import Tbody from "./Tbody";
import PropTypes from "prop-types";

class SimpleTable extends Component {
    static propTypes = {
        columns: PropTypes.array,
        dataSource: PropTypes.array,
    };
    static defaultProps = {
        columns: [],
        dataSource: undefined,
    };

    render() {
        let {columns, dataSource, onExport} = this.props;
        return (
            <div>
                {/*<button onClick={()=>{onExport()}}>*/}
                {/*    خروجی ورد*/}
                {/*</button>*/}
                <table style={{
                    borderCollapse: 'collapse',
                    direction:'rtl',
                    width:'100%',
                    textAlign: 'center',
                    // height:'95%',
                    overflow:'scroll',
                }}>
                    <Thead titles={columns} />
                    <Tbody columns={columns} data={dataSource} />
                </table>
            </div>
        );
    }
}

export default SimpleTable;